import { createFileRoute } from '@tanstack/react-router';

import { Heading } from '@/common/components/heading';
import { Seo } from '@/common/components/seo';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: HomeRoute,
  onEnter: () => {}
});

function HomeRoute() {
  return (
    <>
      <Seo title="Home" />
      <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
        <Heading>Home</Heading>
      </div>
    </>
  );
}
